/**
 * Shared highlight color definitions for Bible highlights.
 * Used across FaithSection, BibleReaderPage, AnnotationsPage, VerseActionSheet, RichJournalEditor.
 */

export const HIGHLIGHT_COLOR_NAMES = ['yellow', 'green', 'blue', 'pink', 'purple'] as const;
export type HighlightColorName = (typeof HIGHLIGHT_COLOR_NAMES)[number];

// The five names are what the database stores; the colours behind them come
// from the palette in index.css, never from raw Tailwind swatches.
export const HIGHLIGHT_COLORS: Record<HighlightColorName, { bg: string; border: string; solid: string }> = {
  yellow: { bg: 'bg-highlight-yellow', border: 'border-highlight-yellow-border', solid: 'bg-highlight-yellow-border' },
  green:  { bg: 'bg-highlight-green',  border: 'border-highlight-green-border',  solid: 'bg-highlight-green-border' },
  blue:   { bg: 'bg-highlight-blue',   border: 'border-highlight-blue-border',   solid: 'bg-highlight-blue-border' },
  pink:   { bg: 'bg-highlight-pink',   border: 'border-highlight-pink-border',   solid: 'bg-highlight-pink-border' },
  purple: { bg: 'bg-highlight-purple', border: 'border-highlight-purple-border', solid: 'bg-highlight-purple-border' },
};

/** Get a bg class for a color name, with fallback */
export function getHighlightBg(color: string): string {
  return HIGHLIGHT_COLORS[color as HighlightColorName]?.bg ?? 'bg-highlight-yellow';
}

/** Get a solid bg class for a color name, with fallback */
export function getHighlightSolid(color: string): string {
  return HIGHLIGHT_COLORS[color as HighlightColorName]?.solid ?? 'bg-primary';
}
